import './sampleGoButton.css'

import { IonButton } from '@ionic/react'
import { FaRandom } from 'react-icons/fa'
import React from 'react'

const SampleGoButton = () => (
	<span className="sample-go-button-wrap">
		<IonButton className="sample-go-button" aria-hidden="true" tabIndex={-1}>
			<FaRandom />
			Go
		</IonButton>
	</span>
)

export default SampleGoButton
